import PreviewEditorial from './PreviewEditorial';
import type { PreviewLayoutProps } from './types';
import './editorialBench.css';

/**
 * E10 arm `editorial_bench`: the editorial page's placement, in Lab Bench's style.
 * Lab Bench lost on tool opens by moving One Step Ahead off the top; this keeps every
 * listing where control puts it and changes only the look.
 */
export default function PreviewEditorialBench(props: PreviewLayoutProps) {
  return <PreviewEditorial {...props} skin="bench" />;
}
